import { Skeleton } from '@mantine/core'

// Loading placeholders that mirror the sidebar's real layout so content
// doesn't jump when the queries resolve. The header and the checklist load
// from separate queries (GET_APPLICANT_BY_ID / GET_SIDEBAR_CHECKLIST_STEPS),
// so each section has its own skeleton.

export const SidebarHeaderSkeleton = () => {
  return (
    <div
      className="flex w-full flex-col gap-3 px-1"
      data-testid="sidebar-header-skeleton"
    >
      <div className="flex w-full flex-row items-center justify-between">
        <Skeleton height={20} width="55%" radius="sm" />
        <Skeleton height={16} width={64} radius="sm" />
      </div>
      <div className="flex flex-row items-center gap-2">
        <Skeleton height={22} width={110} radius="xl" />
        <Skeleton height={22} width={70} radius="xl" />
      </div>
      <Skeleton height={10} width="100%" radius="sm" />
      {[...Array(4)].map((_, index) => (
        <div
          key={index}
          className="flex w-full flex-row items-center justify-between"
        >
          <Skeleton height={12} width="35%" radius="sm" />
          <Skeleton height={12} width="30%" radius="sm" />
        </div>
      ))}
      <div className="flex flex-row items-center gap-2">
        <Skeleton height={28} width={28} circle />
        <Skeleton height={12} width="40%" radius="sm" />
      </div>
    </div>
  )
}

export const ChecklistSkeleton = () => {
  return (
    <div
      className="flex flex-1 flex-col gap-3 overflow-hidden px-1 pt-1"
      data-testid="checklist-skeleton"
    >
      {[...Array(6)].map((_, index) => (
        <div
          key={index}
          className="flex w-full flex-row items-center justify-between"
        >
          <Skeleton height={12} width="45%" radius="sm" />
          <Skeleton height={16} width={72} radius="xl" />
        </div>
      ))}
    </div>
  )
}
